<template>
    <div class="page detail iphone-x-adaptation" :class="{ takeout: pageType == 1 }">
        <template>
            <img class="product-img" :src="productImageUrl" referrerPolicy="no-referrer" />
            <div class="product-name">{{ productName }}</div>
            <div class="product-desc" v-if="descCn" v-html="descCn"></div>
            <div class="product-spu-box" v-if="spu && spuVO && spuVO.layers.length"
                v-for="(layer, index) in spuVO.layers" :key="index">
                <template>
                    <div class="title">
                        {{ layer.layerName }}
                        <span v-if="layer.selectCount > 1 && !layer.isSelectAll">
                            （请选择{{ layer.selectCount }}份）
                        </span>
                    </div>
                    <div class="group-limits" v-if="getLayerGroupLimits(layer).length">
                        <span
                            class="group-limit"
                            :class="{ 'group-limit-full': group.selectedCount >= group.maxSelectCount }"
                            v-for="group in getLayerGroupLimits(layer)"
                            :key="group.selectionGroupId"
                        >
                            {{ group.selectionGroupName }}
                            <template v-if="group.maxSelectCount === 0">本层不可选</template>
                            <template v-else>已选{{ group.selectedCount }}/最多{{ group.maxSelectCount }}份</template>
                        </span>
                    </div>
                    <div class="line" v-if="layer.layerItems.length <= 9">
                        <div class="sku" :class="[
                            { selected: layer.selects.includes(i) },
                            { 'sale-out': (v.saleOut || isSpuGroupForbidden(layer, v)) && !getLayerItemQuantity(layer, i) },
                            {
                                unavailable: isUnavailable(index, i),
                            },
                            {
                                max: !isUnavailable(index, i) && isMaxCount(index),
                            },
                            {
                                'auto-select': layer.isSelectAll && !getLayerGroupLimits(layer).length,
                            },
                            {
                                'all-one': layer.isAllOne,
                            },
                        ]" v-for="(v, i) in layer.layerItems" :key="i" @click="spuCheckLayer(index, i)">
                            <img class="image" :src="v.productImage" alt="" />
                            <div class="purchase-tip" v-if="isMaxPurchaseCount(index, i)">
                                限购{{ v.maxPurchaseCount }}件
                            </div>
                            <div class="name">
                                {{ v.childProductName }}
                                <div class="selection-group-name" v-if="v.selectionGroupName">{{ v.selectionGroupName }}</div>
                            </div>
                            <div class="select-box">
                                <div class="extra-price" :class="{ 'show-symbol': v.extraPrice > 0 }">
                                    <span>{{ v.extraPrice > 0 ? v.extraPrice : '' }}</span>
                                </div>
                                <div class="num-box">
                                    <div class="icon minus" v-if="getLayerItemQuantity(layer, i) > 0"
                                        @click.stop="spuReduceLayerItem(index, i)"></div>
                                    <div class="num" v-if="getLayerItemQuantity(layer, i) > 0">
                                        {{ getLayerItemQuantity(layer, i) }}
                                    </div>
                                    <div class="icon plus"></div>
                                </div>
                                <div class="one-select">
                                    <div class="icon"></div>
                                </div>
                            </div>
                            <div class="mask"></div>
                            <div class="tip">{{ isSpuGroupForbidden(layer, v) ? '本层不可选' : '已售罄' }}</div>
                        </div>
                    </div>
                    <div class="box" v-else>
                        <div class="line-item" :class="[
                            { selected: layer.selects.includes(i) },
                            { 'sale-out': (v.saleOut || isSpuGroupForbidden(layer, v)) && !getLayerItemQuantity(layer, i) },
                            {
                                unavailable: isUnavailable(index, i),
                            },
                            {
                                max: !isUnavailable(index, i) && isMaxCount(index),
                            },
                            {
                                'auto-select': layer.isSelectAll && !getLayerGroupLimits(layer).length,
                            },
                            {
                                'all-one': layer.isAllOne,
                            },
                        ]" v-for="(v, i) in layer.layerItems" :key="i" @click="spuCheckLayer(index, i)">
                            <img class="image" :src="v.productImage" alt="" />
                            <div class="info">
                                <div class="name">
                                    {{ v.childProductName }}
                                </div>
                                <div class="selection-group-name" v-if="v.selectionGroupName">{{ v.selectionGroupName }}</div>
                                <div class="extra-price" v-if="v.extraPrice > 0">+￥{{ v.extraPrice }}</div>
                            </div>
                            <div class="purchase-tip" v-if="isMaxPurchaseCount(index, i)">
                                限购{{ v.maxPurchaseCount }}件
                            </div>
                            <div class="status">
                                <div class="num-box">
                                    <div class="icon minus" @click.stop="spuReduceLayerItem(index, i)"
                                        v-if="getLayerItemQuantity(layer, i) > 0"></div>
                                    <div class="num" v-if="getLayerItemQuantity(layer, i) > 0">
                                        {{ getLayerItemQuantity(layer, i) }}
                                    </div>
                                    <div class="icon plus"></div>
                                </div>
                            </div>
                            <div class="one-select">
                                <div class="icon"></div>
                            </div>
                            <div class="mask"></div>
                            <div class="btn">{{ isSpuGroupForbidden(layer, v) ? '本层不可选' : '已售罄' }}</div>
                        </div>
                    </div>
                </template>
            </div>
            <div class="product-box" v-if="!spu && optionItems && optionItems.length > 0">
                <div class="title">已选餐品</div>
                <div class="product-list iphone-x-adaptation">
                    <div class="product-item" v-for="(item, i) in optionItems" :key="i">
                        <img class="img" :src="item.productImageUrl" />
                        <div class="name">
                            <span class="group-name" v-if="item.groupName">{{ item.groupName }}:</span>
                            {{ item.productName }}
                        </div>
                        <div class="num">{{ item.quantity || 1 }}份</div>
                    </div>
                </div>
            </div>
            <div class="spec-group-box" v-if="!spu && specGroups.length > 0">
                <div class="title">可选餐品</div>
                <div class="product-list iphone-x-adaptation">
                    <div class="spec-group-item">
                        <div class="spec-group-name" @click="switchSku(i)" :class="{ select: i == specIndex }"
                            v-for="(item, i) in specGroups" :key="i">
                            {{ item.productName }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="product-detail-list">
                <img :src="item" :key="item" v-for="item in productDetailImageUrls" />
            </div>
            <div class="padding-bottom"></div>
        </template>
        <!-- <template v-else-if="pageType == 1">
            <img class="product-img" :src="productImageUrl" referrerPolicy="no-referrer" />
            <div class="product-name">{{ productName }}</div>
            <div class="product-desc" v-if="descCn" v-html="descCn"></div>
            <div class="product-box" v-if="type == 2">
                <div class="title">产品</div>
                <div class="group-list">
                    <div
                        class="group-item"
                        v-for="(item, index) in takeoutOriginalProduct.groupItems"
                        :class="{ select: index == takeoutSelectGroupIndex }"
                        :key="index"
                        @click="switchGroupProduct(index)"
                    >
                        {{ item.productName }}
                    </div>
                </div>
            </div>
            <div class="product-box" v-if="takeoutProductInfo.mandatory.length > 0">
                <div class="title">已选餐品</div>
                <div class="product-list iphone-x-adaptation">
                    <div
                        class="product-item"
                        v-for="(item, i) in takeoutProductInfo.mandatory"
                        :key="i"
                    >
                        <img class="img" :src="item.condimentItemList[0].imageUrl" />
                        <div class="name">
                            <span class="group-name" v-if="item.groupName">
                                {{ item.groupName }}:
                            </span>
                            {{ item.condimentItemList[0].productName }}
                        </div>
                        <div class="num">{{ item.condimentItemList[0].quantity || 1 }}份</div>
                    </div>
                </div>
            </div>
            <div
                class="product-box"
                v-for="(groupItem, index) in takeoutProductInfo.need2Select"
                :key="index"
            >
                <div class="title">
                    {{ groupItem.groupName
                    }}{{
                        groupItem.maxItemCount == groupItem.minItemCount
                            ? `(请选择${groupItem.maxItemCount}份)`
                            : `(请选择${groupItem.minItemCount}~${groupItem.maxItemCount}份)`
                    }}
                </div>
                <div class="product-list iphone-x-adaptation">
                    <div
                        class="product-item"
                        v-for="(item, i) in groupItem.condimentItemList"
                        :key="new Date().getTime() + i"
                    >
                        <img class="img" :src="item.imageUrl" />
                        <div class="name">
                            <p>{{ item.productName }}</p>
                            <p class="price" v-if="item.price">加¥{{ item.price }}</p>
                        </div>
                        <div class="quantity-box" v-if="!item.saleOut">
                            <img
                                class="reduce"
                                @click="reduceGroupNum('need2Select', index, i)"
                                v-if="item.count > 0"
                                src="@/assets/icons/icon-circular-reduce.png"
                            />
                            <div class="quantity" v-if="item.count > 0">{{ item.count }}</div>
                            <img
                                class="plus"
                                :class="{
                                    max: groupItem.selectStatus,
                                }"
                                @click="plusGroupNum('need2Select', index, i)"
                                src="@/assets/icons/icon-circular-plus.png"
                            />
                        </div>
                        <div class="sale-out" v-else>已售罄</div>
                    </div>
                </div>
            </div>
            <div
                class="product-box"
                v-for="(groupItem, index) in takeoutProductInfo.optional"
                :key="'group' + index"
            >
                <div class="title">{{ groupItem.groupName }}</div>
                <div class="product-list iphone-x-adaptation">
                    <div
                        class="product-item"
                        v-for="(item, i) in groupItem.condimentItemList"
                        :key="i"
                    >
                        <img class="img" :src="item.imageUrl" />
                        <div class="name">
                            <p>{{ item.productName }}</p>
                            <p class="price" v-if="item.price">加¥{{ item.price }}</p>
                        </div>
                        <div class="quantity-box" v-if="!item.saleOut">
                            <img
                                class="reduce"
                                @click="reduceGroupNum('optional', index, i)"
                                v-if="item.count > 0"
                                src="@/assets/icons/icon-circular-reduce.png"
                            />
                            <div class="quantity" v-if="item.count > 0">{{ item.count }}</div>
                            <img
                                class="plus"
                                :class="{
                                    max: groupItem.selectStatus,
                                }"
                                @click="plusGroupNum('optional', index, i)"
                                src="@/assets/icons/icon-circular-plus.png"
                            />
                        </div>
                        <div class="sale-out" v-else>已售罄</div>
                    </div>
                </div>
            </div>
            <div class="padding-bottom"></div>
        </template> -->
        <div class="cart-box iphone-x-adaptation open-cart" v-if="type == 50">
            <div class="cart-line" :class="{ disabled: spu && !spuSelectProduct }">
                <div class="cart-price" :class="{ disabled: spu && !spuSelectProduct }" @click="toIndex">
                    <div class="content">
                        <div class="price-box">
                            <div class="price">
                                <div class="text">¥{{ total }}</div>
                                <div class="money-discount" v-if="reducePriceTotal > 0">
                                    已省¥{{ reducePriceTotal }}元
                                </div>
                            </div>
                        </div>
                        <div class="submit-btn" @click="addCommit">
                            <div class="title">立即购买</div>
                            <div class="tip">Buy</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="cart-box iphone-x-adaptation open-cart" v-else>
            <div class="quantity-line">
                <div class="quantity-box" :class="{ disabled: quantityDisabled }">
                    <img class="reduce" @click="reduceNum" src="~@/assets/icons/icon-circular-reduce.png" />
                    <div class="quantity">{{ num }}</div>
                    <img class="plus" :class="{ max: num >= maxQty && maxQty != -1 }" @click="plusNum"
                        src="~@/assets/icons/icon-circular-plus.png" />
                </div>
            </div>
            <div class="cart-line" :class="{ disabled: spu && !spuSelectProduct }">
                <div class="cart-price" :class="{ disabled: spu && !spuSelectProduct }">
                    <div class="content">
                        <div class="price-box">
                            <div class="price">
                                <div class="text">¥{{ total }}</div>
                                <div class="money-discount" v-if="reducePriceTotal > 0">
                                    已省¥{{ reducePriceTotal }}元
                                </div>
                            </div>
                        </div>
                        <div class="submit-btn" @click="addCart">
                            <div class="title">加入购物车</div>
                            <div class="tip">Add Cart</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="page detail iphone-x-adaptation" v-if="pageType == 0">
        <div class="bottom iphone-x-adaptation">
            <div class="price-line" v-if="$store.getters.getExposeMethod.showOriginalPrice">
                <div class="price-text">到手价</div>
                <div class="total">{{ total }}</div>
                <div class="actual-payment">
                    实付¥{{ originalTotal }}元，到手后返现¥{{ reducePriceTotal }}元
                </div>
                <div class="quantity-box">
                    <img
                        class="reduce"
                        @click="reduceNum"
                        src="@/assets/icons/icon-circular-reduce.png"
                    />
                    <div class="num">{{ num }}</div>
                    <img
                        class="plus"
                        :class="{ max: num >= maxQty && maxQty != -1 }"
                        @click="plusNum"
                        src="@/assets/icons/icon-circular-plus.png"
                    />
                </div>
            </div>
            <div class="price-line" v-else>
                <div class="total">
                    {{ total
                    }}{{ xiaoBuDianIntegralTotal ? '+' + xiaoBuDianIntegralTotal + '积分' : ''
                    }}{{ jiMiWuXianIntegralTotal ? '+' + jiMiWuXianIntegralTotal + '能量' : '' }}
                </div>
                <div class="quantity-box">
                    <img
                        class="reduce"
                        @click="reduceNum"
                        src="@/assets/icons/icon-circular-reduce.png"
                    />
                    <div class="num">{{ num }}</div>
                    <img
                        class="plus"
                        :class="{ max: num >= maxQty && maxQty != -1 }"
                        @click="plusNum"
                        src="@/assets/icons/icon-circular-plus.png"
                    />
                </div>
            </div>
            <div class="btn-submit iphone-x-adaptation" @click="addCart">加入购物车</div>
        </div>
    </div> -->
    <!-- <div class="page detail takeout iphone-x-adaptation" v-else-if="pageType == 1">
        <div class="bottom iphone-x-adaptation" :class="{ 'takeout-select-no': !takeoutOkStatus }">
            <div class="price-line" v-if="$store.getters.getExposeMethod.showOriginalPrice">
                <div class="price-text">到手价</div>
                <div class="total">{{ total }}</div>
                <div class="actual-payment">
                    实付¥{{ originalTotal }}元，到手后返现¥{{ reducePriceTotal }}元
                </div>
                <div class="quantity-box">
                    <img
                        class="reduce"
                        @click="reduceNum"
                        src="@/assets/icons/icon-circular-reduce.png"
                    />
                    <div class="num">{{ num }}</div>
                    <img
                        class="plus"
                        :class="{ max: num >= maxQty && maxQty != -1 }"
                        @click="plusNum"
                        src="@/assets/icons/icon-circular-plus.png"
                    />
                </div>
            </div>
            <div class="price-line" v-else>
                <div class="total">
                    {{ total
                    }}{{ xiaoBuDianIntegralTotal ? '+' + xiaoBuDianIntegralTotal + '积分' : ''
                    }}{{ jiMiWuXianIntegralTotal ? '+' + jiMiWuXianIntegralTotal + '能量' : '' }}
                </div>
                <div class="quantity-box">
                    <img
                        class="reduce"
                        @click="reduceNum"
                        src="@/assets/icons/icon-circular-reduce.png"
                    />
                    <div class="num">{{ num }}</div>
                    <img
                        class="plus"
                        :class="{ max: num >= maxQty && maxQty != -1 }"
                        @click="plusNum"
                        src="@/assets/icons/icon-circular-plus.png"
                    />
                </div>
            </div>
            <div class="btn-submit iphone-x-adaptation" @click="addCart">加入购物车</div>
        </div>
    </div> -->
</template>
<script>
import { ADD_PRODUCT_FOR_CART } from 'api';
import { QZ_KFC_CART_NAME, QZ_KFC_PRODUCT_INFO } from 'constant';
import { PAGE_ADDRESS_LIST } from 'page';
import number from '@/lib/number';
import {
    initializeSpuSelection,
    getLayerItemQuantity,
    getLayerGroupLimits,
    isSpuItemUnavailable,
    selectSpuItem,
    reduceSpuItem,
    getSelectedSpuProduct,
    getSpuSelectionError,
} from '@/lib/kfcSpuSelection';
export default {
    data() {
        return {
            type: '',
            storeCode: '',
            productId: '',
            accountId: '',
            accountType: '',
            _productId: '',
            productName: '',
            productImageUrl: '',
            originalTotalPrice: '',
            descCn: '',
            price: '',
            productDetailImageUrls: [],
            optionItems: [],
            spu: false,
            spuVO: {
                layers: [],
            },

            items: [],
            specGroups: [],
            specIndex: -1,
            num: 1,
            maxQty: -1,
            reduce_price: '',
            limitActivity: null,
            purchasedQuantity: 0,
            addressId: '',
            takeoutOriginalProduct: {},
            takeoutSelectGroupIndex: -1,
            takeoutProductInfo: {
                mandatory: [],
                need2Select: [],
                optional: [],
            },
            takeoutOkStatus: false,
            bookingTime: null,
        };
    },
    computed: {
        originalTotal() {
            if (this.specIndex == -1) {
                return number.operation(`${this.originalTotalPrice}*${this.num}`);
            } else {
                return number.operation(`${this.specGroups[this.specIndex].originalTotalPrice}*${this.num}`);
            }
        },
        total() {
            if (this.spuSelectProduct) {
                return +number.operation(`${this.spuSelectProduct.price}*${this.num}`);
            } else if (this.specIndex == -1) {
                return +(+number.operation(`${this.price}*${this.num}`)).toFixed(2);
            } else {
                return +number.operation(`${this.specGroups[this.specIndex].price}*${this.num}`);
            }
        },
        xiaoBuDianIntegralTotal() {
            if (this.$store.getters.getExposeMethod.customizedXiaoBuDian) {
                if (this.specIndex == -1) {
                    let reduce = number.operation(`${this.originalTotalPrice}-${this.price}`);
                    return +number.operation(`${reduce}*${this.num * 20}`);
                } else {
                    let reduce = number.operation(
                        `${this.specGroups[this.specIndex].originalTotalPrice}-${this.specGroups[this.specIndex].price}`
                    );
                    return +number.operation(`${reduce}*${this.num * 20}`);
                }
            } else {
                return 0;
            }
        },
        jiMiWuXianIntegralTotal() {
            if (this.$store.getters.getExposeMethod.customizedJiMiWuXian) {
                if (this.specIndex == -1) {
                    let reduce = number.operation(`${this.originalTotalPrice}-${this.price}`);
                    return +number.operation(`${reduce}*${this.num * 10}`);
                } else {
                    let reduce = number.operation(
                        `${this.specGroups[this.specIndex].originalTotalPrice}-${this.specGroups[this.specIndex].price}`
                    );
                    return +number.operation(`${reduce}*${this.num * 10}`);
                }
            } else {
                return 0;
            }
        },
        reducePriceTotal() {
            if (this.spuSelectProduct) {
                let reduce_price = number.operation(
                    `${this.spuSelectProduct.originalTotalPrice}-${this.spuSelectProduct.price}`
                );
                return +number.operation(`${reduce_price}*${this.num}`);
            } else if (this.specIndex == -1) {
                return +number.operation(`${this.reduce_price}*${this.num}`);
            } else {
                var item = this.specGroups[this.specIndex];
                var reduce_price = number.operation(`${item.originalTotalPrice}-${item.price}`);
                return +number.operation(`${reduce_price}*${this.num}`);
            }
        },
        takeout() {
            return this.pageType == 1;
        },
        // 宅急送浏览态：尚未选择收货地址
        isBrowseMode() {
            return this.pageType == 1 && !+this.addressId;
        },
        spuSelectProduct() {
            return this.spu ? getSelectedSpuProduct(this.spuVO) : null;
        },
        // SPU 未选出可售组合时不可调整数量
        quantityDisabled() {
            return this.spu && !this.spuSelectProduct;
        },
    },
    created() {
        var productInfo = JSON.parse(window.localStorage.getItem(QZ_KFC_PRODUCT_INFO));
        this.pageType = productInfo.pageType || 0;
        this.type = productInfo.type;
        this.productId = productInfo.productId;
        this._productId = productInfo._productId;
        this.addressId = productInfo.addressId;
        this.productName = productInfo.productName;
        this.productImageUrl = productInfo.productImageUrl;
        this.descCn = productInfo.descCn;
        this.productDetailImageUrls = productInfo.productDetailImageUrls || [];
        this.optionItems = productInfo.optionItems;
        this.spu = productInfo.spu;
        if (this.spu) {
            this.spuVO = initializeSpuSelection(productInfo.spuVO);
        }

        if (this.type == 3) {
            this.maxQty = Number(productInfo.maxQty) || -1;
        }
        if (this.type == 2 || this.type == 3) {
            this.price = productInfo.price;
            this.reduce_price = productInfo.reduce_price || '';
            this.originalTotalPrice = productInfo.originalTotalPrice || '';
            this.getTakeoutProduct();
            return;
        } else if (this.type == 1) {
            this.takeoutOkStatus = true;
        } else if (this.type == 10) {
            this.accountId = productInfo.accountId;
            this.accountType = productInfo.accountType;
        }
        this.storeCode = productInfo.storeCode;
        this.specGroups = productInfo.specGroups;
        if (this.specGroups.length > 0) {
            this.specIndex = 0;
            this.productImageUrl = this.specGroups[0].productImageUrl;
        }
        this.price = this.specGroups.length > 0 ? this.specGroups[this.specIndex].price : productInfo.price;

        this.productId = this.specGroups.length > 0 ? this.specGroups[this.specIndex].productId : productInfo.productId;
        this.items = productInfo.items || [];
        this.num = 1;
        this.maxQty = Number(productInfo.maxQty) || -1;
        this.reduce_price = productInfo.reduce_price || '';
        this.limitActivity = productInfo.limitActivity || null;
        this.purchasedQuantity = productInfo.purchasedQuantity || 0;
        this.originalTotalPrice = productInfo.originalTotalPrice || '';
        this.xiaoBuDianIntegral = productInfo.xiaoBuDianIntegral || 0;

        this.bookingTime = this.$route.query.bookingTime;
    },
    methods: {
        getTakeoutProduct() {
            this.$util
                .post('/api/kfcMenu/getTakeoutProduct', {
                    addressId: this.addressId,
                    productId: this.productId,
                    productType: this.type,
                })
                .then(res => {
                    if (res.success) {
                        if (res.data.productType == 3) {
                            this.takeoutOriginalProduct = Object.assign({}, res.data, {
                                price: this.price,
                                originalTotalPrice: this.originalTotalPrice,
                            });
                            this.takeoutProductInfo = {
                                mandatory: [],
                                need2Select: [],
                                optional: [],
                            };
                            this.maxQty = res.data.dynamicProduct.maxQty || this.maxQty || 99;
                            for (let i = 0; i < res.data.dynamicProduct.condimentRoundList.length; i++) {
                                const item = res.data.dynamicProduct.condimentRoundList[i];
                                this.takeoutProductClassification(item);
                            }
                            this.inspectTakeoutProductSelectStatus();
                        } else if (res.data.productType == 2) {
                            this.takeoutOriginalProduct = res.data;
                            for (let i = 0; i < res.data.groupItems.length; i++) {
                                const item = res.data.groupItems[i];
                                if (!item.saleOut) {
                                    this.takeoutSelectGroupIndex = i;
                                    break;
                                }
                            }

                            if (this.takeoutSelectGroupIndex == -1) {
                                return this.$toast('该商品已售罄');
                            }

                            this.takeoutProductInfo = {
                                mandatory: [],
                                need2Select: [],
                                optional: [],
                            };
                            let groupItem = res.data.groupItems[this.takeoutSelectGroupIndex];
                            this.maxQty = groupItem.maxQty || 99;
                            if (groupItem.type == 1) {
                                this.takeoutOkStatus = true;
                                this.price = groupItem.price;
                                this.originalTotalPrice = groupItem.originalPrice;
                            } else {
                                for (let i = 0; i < groupItem.condimentRoundList.length; i++) {
                                    const item = groupItem.condimentRoundList[i];
                                    this.takeoutProductClassification(item);
                                }
                                this.inspectTakeoutProductSelectStatus();
                            }
                        }
                    }
                });
        },
        // 外卖商品分类
        takeoutProductClassification(item) {
            // 可选
            if (item.minItemCount == 0) {
                let tempSetCount = false;
                for (let j = 0; j < item.condimentItemList.length; j++) {
                    const v = item.condimentItemList[j];
                    v.count = 0;
                    v.quantity = v.count;
                }
                this.takeoutProductInfo.optional.push(item);
            }
            // 必须
            else if (item.minItemCount == item.maxItemCount && item.condimentItemList.length == 1) {
                item.condimentItemList[0].count = item.condimentItemList[0].quantity;
                this.takeoutProductInfo.mandatory.push(item);
            }
            // 有数量的可选
            else {
                let tempSetCount = false;
                for (let j = 0; j < item.condimentItemList.length; j++) {
                    const v = item.condimentItemList[j];
                    if (!v.saleOut && !tempSetCount) {
                        v.count = v.quantity;
                        tempSetCount = true;
                    } else {
                        v.count = 0;
                        v.quantity = v.count;
                    }
                }
                this.takeoutProductInfo.need2Select.push(item);
            }
        },
        // 检查状态
        inspectTakeoutProductSelectStatus() {
            let tempTakeoutSelectOKStatus = true;
            for (let i = 0; i < this.takeoutProductInfo.need2Select.length; i++) {
                const groupItem = this.takeoutProductInfo.need2Select[i];
                let tempCount = 0;
                for (let j = 0; j < groupItem.condimentItemList.length; j++) {
                    const item = groupItem.condimentItemList[j];
                    tempCount += item.count;
                }
                if (tempCount >= groupItem.maxItemCount) {
                    groupItem.selectStatus = true;
                } else {
                    groupItem.selectStatus = false;
                    tempTakeoutSelectOKStatus = false;
                }
            }
            for (let i = 0; i < this.takeoutProductInfo.optional.length; i++) {
                const groupItem = this.takeoutProductInfo.optional[i];
                let tempCount = 0;
                for (let j = 0; j < groupItem.condimentItemList.length; j++) {
                    const item = groupItem.condimentItemList[j];
                    tempCount += item.count;
                }
                if (tempCount >= groupItem.maxItemCount) {
                    groupItem.selectStatus = true;
                } else {
                    groupItem.selectStatus = false;
                }
            }
            this.takeoutOkStatus = tempTakeoutSelectOKStatus;
            this.setTakeoutPrice();
        },
        // 计算价格
        setTakeoutPrice() {
            let tempAdditionalPrice = 0;
            let tempOriginPrice = 0;
            this.originalTotalPrice = this.takeoutOriginalProduct.originalTotalPrice;
            for (let i = 0; i < this.takeoutProductInfo.need2Select.length; i++) {
                const groupItem = this.takeoutProductInfo.need2Select[i];

                for (let j = 0; j < groupItem.condimentItemList.length; j++) {
                    const item = groupItem.condimentItemList[j];
                    if (item.count) {
                        let tempTotal = number.operation(`${item.price}*${item.count}`);
                        let tempOriginTotal = number.operation(`${item.originPrice}*${item.count}`);
                        tempAdditionalPrice = number.operation(`${tempTotal}+${tempAdditionalPrice}`);
                        tempOriginPrice = number.operation(`${tempOriginPrice}+${tempOriginTotal}`);
                    }
                }
            }

            for (let i = 0; i < this.takeoutProductInfo.optional.length; i++) {
                const groupItem = this.takeoutProductInfo.optional[i];

                for (let j = 0; j < groupItem.condimentItemList.length; j++) {
                    const item = groupItem.condimentItemList[j];
                    if (item.count) {
                        let tempTotal = number.operation(`${item.price}*${item.count}`);
                        let tempOriginTotal = number.operation(`${item.originPrice}*${item.count}`);
                        tempAdditionalPrice = number.operation(`${tempTotal}+${tempAdditionalPrice}`);
                        tempOriginPrice = number.operation(`${tempOriginPrice}+${tempOriginTotal}`);
                    }
                }
            }
            if (this.takeoutOriginalProduct.productType == 3) {
                this.price = number.operation(`${this.takeoutOriginalProduct.price}+${tempAdditionalPrice}`);
                this.originalTotalPrice = number.operation(`${this.originalTotalPrice}+${tempOriginPrice}`);
            } else if (this.takeoutOriginalProduct.productType == 2) {
                this.price = number.operation(
                    `${this.takeoutOriginalProduct.groupItems[this.takeoutSelectGroupIndex].price
                    }+${tempAdditionalPrice}`
                );

                this.originalTotalPrice = number.operation(
                    `${this.takeoutOriginalProduct.groupItems[this.takeoutSelectGroupIndex].originalTotalPrice
                    }+${tempOriginPrice}`
                );
            }
            this.reduce_price = number.operation(`${this.originalTotalPrice}-${this.price}`);

            this.$forceUpdate();
        },
        // 减少需选择数量
        reduceGroupNum(type, i, j, num = 1) {
            if (type == 'need2Select') {
                this.takeoutProductInfo.need2Select[i].condimentItemList[j].count -= num;
                this.takeoutProductInfo.need2Select[i].condimentItemList[j].count =
                    this.takeoutProductInfo.need2Select[i].condimentItemList[j].count || 0;
                this.inspectTakeoutProductSelectStatus();
            } else if (type == 'optional') {
                this.takeoutProductInfo.optional[i].condimentItemList[j].count -= num;
                this.takeoutProductInfo.optional[i].condimentItemList[j].count =
                    this.takeoutProductInfo.optional[i].condimentItemList[j].count || 0;
                this.inspectTakeoutProductSelectStatus();
            }
        },
        // 增加需选择数量
        plusGroupNum(type, i, j, num = 1) {
            if (type == 'need2Select') {
                let tempCount = 0;
                for (let k = 0; k < this.takeoutProductInfo.need2Select[i].condimentItemList.length; k++) {
                    const item = this.takeoutProductInfo.need2Select[i].condimentItemList[k];
                    tempCount += item.count;
                }

                if (this.takeoutProductInfo.need2Select[i].maxItemCount > tempCount) {
                    this.takeoutProductInfo.need2Select[i].condimentItemList[j].count += num;
                    this.inspectTakeoutProductSelectStatus();
                }
            } else if (type == 'optional') {
                let tempCount = 0;
                for (let k = 0; k < this.takeoutProductInfo.optional[i].condimentItemList.length; k++) {
                    const item = this.takeoutProductInfo.optional[i].condimentItemList[k];
                    tempCount += item.count;
                }
                if (this.takeoutProductInfo.optional[i].maxItemCount > tempCount) {
                    this.takeoutProductInfo.optional[i].condimentItemList[j].count += num;
                    this.inspectTakeoutProductSelectStatus();
                }
            }
        },
        // 选择sku
        switchSku(i) {
            this.specIndex = i;
            this.productId = this.specGroups[i].productId;
            this.productImageUrl = this.specGroups[i].productImageUrl;
            this.specGroups[i].descCn && (this.descCn = this.specGroups[i].descCn);
            this.price = this.specGroups[i].price;
        },
        // 减少数量
        reduceNum() {
            if (this.quantityDisabled) {
                return;
            }
            if (this.num > 1) {
                this.num--;
            }
        },
        // 增加数量
        plusNum() {
            if (this.quantityDisabled) {
                return;
            }
            if (this.num >= this.maxQty && this.maxQty != -1) {
                return this.$toast('亲～已经达到最大限购啦');
            }
            if (
                this.limitActivity &&
                this.limitActivity.totalEveryDayCanPurchaseCount <=
                this.limitActivity.totalTodayPurchasedCount + this.purchasedQuantity + this.num
            ) {
                return this.$toast(`[${this.productName}]今日已售罄，明天再来看看吧。`);
            } else if (
                this.limitActivity &&
                this.limitActivity.userEveryDayCanPurchaseCount <=
                this.limitActivity.userTodayPurchasedCount + this.purchasedQuantity + this.num
            ) {
                return this.$toast(`[${this.productName}]今日已售罄，明天再来看看吧。`);
            }

            this.num++;

            // if (this.pageType == 0) {
            //     if (
            //         this.limitActivity &&
            //         this.limitActivity.totalEveryDayCanPurchaseCount <=
            //             this.limitActivity.totalTodayPurchasedCount +
            //                 this.purchasedQuantity +
            //                 this.num
            //     ) {
            //         return this.$toast(`[${this.productName}]今日已售罄，明天再来看看吧。`);
            //     } else if (
            //         this.limitActivity &&
            //         this.limitActivity.userEveryDayCanPurchaseCount <=
            //             this.limitActivity.userTodayPurchasedCount +
            //                 this.purchasedQuantity +
            //                 this.num
            //     ) {
            //         return this.$toast(`[${this.productName}]今日已售罄，明天再来看看吧。`);
            //     }
            // }
        },
        // 加入购物车
        addCart() {
            let selectedSpuProduct = null;
            if (this.spu) {
                const error = getSpuSelectionError(this.spuVO);
                selectedSpuProduct = getSelectedSpuProduct(this.spuVO);
                if (error || !selectedSpuProduct) {
                    return this.$toast(error || '所选商品暂不可用，请重新选择');
                }
            }
            let requestData = {
                accountId: this.accountId,
                accountType: this.accountType,
                productId: this.productId,
                quantity: this.num,
                storeCode: this.storeCode,
                takeout: this.takeout,
                bookingTime: this.bookingTime,
            };
            if (this.spu) {
                requestData.accountId = selectedSpuProduct.accountId;
                requestData.accountType = selectedSpuProduct.accountType;
                requestData.productId = selectedSpuProduct.productId;
            }
            if (this.isBrowseMode) {
                return this.toPickAddress();
            }
            this.$util.eventStatistics({
                title: 'AddOnLineCart',
            });
            this.$util.post(ADD_PRODUCT_FOR_CART, requestData).then(res => {
                if (res.success) {
                    this.$util.pageBack();
                }
            });
        },
        // 立即购买
        addCommit() {
            let selectedSpuProduct = null;
            if (this.spu) {
                const error = getSpuSelectionError(this.spuVO);
                selectedSpuProduct = getSelectedSpuProduct(this.spuVO);
                if (error || !selectedSpuProduct) {
                    return this.$toast(error || '所选商品暂不可用，请重新选择');
                }
            }
            let requestData = {
                accountId: this.spu ? selectedSpuProduct.accountId : this.accountId,
                accountType: this.spu ? selectedSpuProduct.accountType : this.accountType,
                productId: this.spu ? selectedSpuProduct.productId : this.productId,
                quantity: this.num,
                storeCode: this.storeCode,
                takeout: this.takeout,
                bookingTime: this.bookingTime,
            };
            if (this.isBrowseMode) {
                return this.toPickAddress();
            }
            this.$util.eventStatistics({
                title: 'BuyNow',
            });
            this.$util.post(ADD_PRODUCT_FOR_CART, requestData).then(res => {
                if (res.success) {
                    this.$util.pageBack();
                }
            });
        },
        // 浏览态：先选择收货地址，替换当前页，选完后返回菜单页
        toPickAddress() {
            this.$util.pageJump(PAGE_ADDRESS_LIST, { type: 7 }, {}, { jumpType: 1 });
        },
        // 切换group商品
        switchGroupProduct(index) {
            let item = this.takeoutOriginalProduct.groupItems[index];
            if (item.saleOut) {
                return this.$toast('已售罄');
            }
            this.takeoutSelectGroupIndex = index;
            if (item.type == 1) {
                this.takeoutOkStatus = true;
                this.price = item.price;
                this.originalTotalPrice = item.originalPrice;
            } else {
                this.takeoutProductInfo = {
                    mandatory: [],
                    need2Select: [],
                    optional: [],
                };

                let list = item.condimentRoundList;
                for (let i = 0; i < list.length; i++) {
                    const item = list[i];
                    this.takeoutProductClassification(item);
                }
                this.inspectTakeoutProductSelectStatus();
            }
        },
        // spu选择sku
        spuCheckLayer(layerIndex, index) {
            const error = selectSpuItem(this.spuVO, layerIndex, index);
            if (error) this.$toast(error);
        },
        spuReduceLayerItem(layerIndex, index) {
            reduceSpuItem(this.spuVO, layerIndex, index);
        },
        getLayerItemQuantity,
        getLayerGroupLimits,
        isSpuGroupForbidden(layer, item) {
            return getLayerGroupLimits(layer).some(group =>
                group.maxSelectCount === 0 && String(group.selectionGroupId) === String(item.selectionGroupId)
            );
        },
        isMaxPurchaseCount(layerIndex, index) {
            const currentLayer = this.spuVO.layers[layerIndex];
            const currentItem = currentLayer.layerItems[index];
            return currentLayer.selectCount > currentItem.maxPurchaseCount;
        },
        isMaxCount(layerIndex) {
            const currentLayer = this.spuVO.layers[layerIndex];

            return currentLayer.selects.length >= currentLayer.selectCount;
        },
        // 判断是否可选中
        isUnavailable(layerIndex, index) {
            return isSpuItemUnavailable(this.spuVO, layerIndex, index);
        },
    },
};
</script>
<style lang="less" scoped>
@import url('~@/lib/base.less');
@bottomHeight: .pxToRem(176) [];
@bottomPriceLineHeight: .pxToRem(88) [];
@bottomAddCartHeight: calc(.pxToRem(176) [] - .pxToRem(88) []);

.spu-selected-quantity {
    color: @theme_color_first;
    white-space: nowrap;

    .reduce {
        display: inline-block;
        padding: 0 .pxToRem(8) [];
        font-weight: bold;
    }
}

.page {
    background: white;
    min-height: 100%;
    box-sizing: border-box;
}

.padding-bottom {
    height: .pxToRem(248) [];
}

.product-img {
    width: 100%;
}

.product-name {
    width: 100%;
    box-sizing: border-box;
    padding: .pxToRem(20) [] .pxToRem(40) [];
    line-height: .pxToRem(60) [];
    font-size: .pxToRem(40) [];
    color: rgba(0, 0, 0, 0.9);
    font-weight: 600;

    &:before {
        content: ' ';
        position: absolute;
        top: 0;
        left: .pxToRem(40) [];
        right: .pxToRem(40) [];
        height: .pxToRem(1) [];
        background: #000;
    }

    &:after {
        content: ' ';
        position: absolute;
        bottom: 0;
        left: .pxToRem(40) [];
        right: .pxToRem(40) [];
        height: .pxToRem(1) [];
        background: #000;
    }
}

.product-desc {
    padding: .pxToRem(30) [] .pxToRem(40) [];
    font-size: .pxToRem(26) [];
    line-height: .pxToRem(40) [];
    color: rgba(0, 0, 0, 0.9);
    white-space: pre-wrap;
}

.product-spu-box {
    .group-limits {
        display: flex;
        flex-wrap: wrap;
        padding: 0 .pxToRem(24) [];
        margin-bottom: .pxToRem(16) [];
    }

    .group-limit {
        max-width: 100%;
        margin-right: .pxToRem(12) [];
        margin-bottom: .pxToRem(8) [];
        padding: .pxToRem(4) [] .pxToRem(12) [];
        border-radius: .pxToRem(8) [];
        background: #f7f7f7;
        color: #666;
        font-size: .pxToRem(22) [];
        line-height: .pxToRem(32) [];
        overflow-wrap: break-word;

        &.group-limit-full {
            color: #e40031;
        }
    }

    .selection-group-name {
        color: #666;
        font-size: .pxToRem(20) [];
        line-height: .pxToRem(28) [];
        overflow-wrap: break-word;
    }

    .title {
        height: .pxToRem(40) [];
        line-height: .pxToRem(40) [];
        color: rgba(0, 0, 0, 0.9);
        font-size: .pxToRem(28) [];
        font-weight: 600;
        margin-top: .pxToRem(30) [];
        margin-bottom: .pxToRem(30) [];
        text-indent: .pxToRem(54) [];

        &::before {
            content: ' ';
            position: absolute;
            left: .pxToRem(40) [];
            top: 50%;
            transform: translateY(-50%);
            height: .pxToRem(28) [];
            width: .pxToRem(8) [];
            border-radius: .pxToRem(8) [];
            background: #000;
        }
    }

    .line {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        /* 三列等宽 */
        gap: .pxToRem(16) [];
        /* 可选：项目间距 */
        padding: 0 .pxToRem(24) [];

        .sku {
            border: .pxToRem(4) [] solid #f7f7f7;
            border-radius: .pxToRem(4) [];
            font-size: 0;
            background: #f7f7f7;

            .image {
                width: 100%;
            }

            .purchase-tip {
                position: absolute;
                top: .pxToRem(108) [];
                left: 50%;
                transform: translateX(-50%);
                width: .pxToRem(120) [];
                line-height: .pxToRem(36) [];
                text-align: center;
                border-radius: .pxToRem(18) [];
                font-size: .pxToRem(24) [];
                color: white;
                background: rgba(0, 0, 0, 0.6);
            }

            .name {
                text-align: center;
                font-size: .pxToRem(20) [];
                line-height: .pxToRem(40) [];
                min-height: .pxToRem(60) [];
                margin-bottom: .pxToRem(60) [];
                color: black;
            }

            .select-box {
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                display: flex;
                height: .pxToRem(60) [];
                // margin-top: .pxToRem(20) [];
                justify-content: space-between;
                align-items: center;
            }

            .extra-price {
                font-size: .pxToRem(24) [];
                margin-left: .pxToRem(10) [];
                font-weight: bold;
                color: #e40031;

                &.show-symbol::before {
                    content: '+￥';
                    letter-spacing: .pxToRem(-4) [];
                }
            }

            .num-box {
                display: flex;
            }

            .icon {
                width: .pxToRem(40) [];
                height: .pxToRem(40) [];
                margin-right: .pxToRem(10) [];

                &.plus {
                    background: url('~@/assets/icons/icon-circular-plus-40.png');
                    background-size: cover;
                }

                &.minus {
                    background: url('~@/assets/icons/icon-circular-reduce-40.png');
                    background-size: cover;
                }
            }

            .num {
                text-align: center;
                margin-right: .pxToRem(10) [];
                line-height: .pxToRem(40) [];
                font-size: .pxToRem(24) [];
            }

            .mask {
                display: none;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: rgba(255, 255, 255, 0.6);
            }

            .tip {
                display: none;
                position: absolute;
                top: .pxToRem(60) [];
                left: 50%;
                transform: translateX(-50%);
                width: .pxToRem(108) [];
                height: .pxToRem(44) [];
                line-height: .pxToRem(44) [];
                text-align: center;
                font-size: .pxToRem(20) [];
                background: rgba(0, 0, 0, 0.6);
                color: white;
                border-radius: .pxToRem(44) [];
            }

            .one-select {
                display: none;

                .icon {
                    .sq(40);
                    background: url('~@/assets/icons/icon-circular-select-no.png');
                    background-size: cover;
                }
            }

            &.selected {
                border-color: @theme_color_first;
                background: white;
            }

            &.sale-out {
                .icon {
                    background: url('~@/assets/icons/icon-circular-select-not.png');
                    background-size: cover;
                }

                .purchase-tip {
                    display: none;
                }

                .mask,
                .tip {
                    display: block;
                }
            }

            &.unavailable,
            &.max {
                .icon {
                    &.plus {
                        background: url('~@/assets/icons/icon-circular-plus-not-40.png');
                        background-size: cover;
                    }
                }

                // .mask,
                // .tip {
                //     display: block;
                // }
            }

            &.auto-select {
                .purchase-tip {
                    display: none;
                }

                .num-box {
                    .icon {
                        display: none;
                    }

                    .num {
                        &::after {
                            content: '份';
                        }
                    }
                }
            }

            &.all-one {
                .num-box {
                    display: none;
                }

                .one-select {
                    display: block;
                }

                &.selected {
                    .one-select {
                        .icon {
                            background: url('~@/assets/icons/icon-circular-select.png');
                            background-size: cover;
                        }
                    }
                }
            }
        }
    }

    .box {
        padding: .pxToRem(0) [] .pxToRem(24) [];

        .line-item {
            display: flex;
            padding: .pxToRem(6) [] .pxToRem(8) [];
            background: #f7f7f7;
            border: .pxToRem(4) [] solid #f7f7f7;
            border-radius: .pxToRem(6) [];
            align-items: center;

            .image {
                height: .pxToRem(76) [];
                margin-right: .pxToRem(10) [];
                border-radius: .pxToRem(6) [];
            }

            .info {
                display: flex;
                flex: 1;
                min-width: 0;
                flex-direction: column;
                justify-content: center;

                .name {
                    .overflow(2);
                    line-height: .pxToRem(40) [];
                    font-size: .pxToRem(28) [];
                    color: #030001;
                }

                .extra-price {
                    height: .pxToRem(28) [];
                    line-height: .pxToRem(28) [];
                    font-size: .pxToRem(20) [];
                    color: #e40031;
                }
            }

            .num-box {
                display: flex;

                .num {
                    line-height: .pxToRem(40) [];
                    font-size: .pxToRem(24) [];
                    margin-right: .pxToRem(10) [];
                }
            }

            .icon {
                width: .pxToRem(40) [];
                height: .pxToRem(40) [];
                margin-right: .pxToRem(10) [];

                &.plus {
                    background: url('~@/assets/icons/icon-circular-plus-40.png');
                    background-size: cover;
                }

                &.minus {
                    background: url('~@/assets/icons/icon-circular-reduce-40.png');
                    background-size: cover;
                }
            }

            .purchase-tip {
                margin-right: .pxToRem(20) [];
                line-height: .pxToRem(40) [];
                padding: 0 .pxToRem(20) [];
                border-radius: .pxToRem(20) [];
                background: rgba(0, 0, 0, 0.6);
                color: white;
            }

            .btn {
                display: none;
                background: #7e7e7e;
                width: .pxToRem(106) [];
                height: .pxToRem(44) [];
                line-height: .pxToRem(44) [];
                text-align: center;
                font-size: .pxToRem(20) [];
                color: white;
                border-radius: .pxToRem(22) [];
            }

            .mask {
                display: none;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: rgba(255, 255, 255, 0.6);
            }

            +.line-item {
                margin-top: .pxToRem(10) [];
            }

            .one-select {
                display: none;

                .icon {
                    .sq(40);
                    background: url('~@/assets/icons/icon-circular-select-no.png');
                    background-size: cover;
                }
            }

            &.selected {
                border-color: @theme_color_first;
                background: white;
            }

            &.sale-out {

                .purchase-tip,
                .status,
                .one-select {
                    display: none !important;
                }

                .mask,
                .btn {
                    display: block;
                }
            }

            &.unavailable,
            &.max {
                .icon {
                    &.plus {
                        background: url('~@/assets/icons/icon-circular-plus-not-40.png');
                        background-size: cover;
                    }
                }
            }

            &.auto-select {
                .purchase-tip {
                    display: none;
                }

                .num-box {
                    .icon {
                        display: none;
                    }

                    .num {
                        &::after {
                            content: '份';
                        }
                    }
                }
            }

            &.all-one {
                .status {
                    display: none;
                }

                .one-select {
                    display: block;
                }

                &.selected {
                    .one-select {
                        .icon {
                            background: url('~@/assets/icons/icon-circular-select.png');
                            background-size: cover;
                        }
                    }
                }
            }
        }
    }
}

.product-box,
.spec-group-box {
    .title {
        height: .pxToRem(40) [];
        line-height: .pxToRem(40) [];
        color: rgba(0, 0, 0, 0.9);
        font-size: .pxToRem(30) [];
        font-weight: 600;
        margin-top: .pxToRem(30) [];
        margin-bottom: .pxToRem(30) [];
        text-indent: .pxToRem(40) [];
    }

    .product-list {
        .product-item {
            width: 100%;
            height: .pxToRem(88) [];
            margin-bottom: .pxToRem(10) [];

            .img {
                .base-center-y;
                left: .pxToRem(120) [];
                max-width: .pxToRem(110) [];
                max-height: .pxToRem(80) [];
            }

            .name {
                .base-center-y;
                left: .pxToRem(250) [];
                right: .pxToRem(120) [];
                line-height: .pxToRem(40) [];
                font-size: .pxToRem(28) [];
                color: #1f1f1f;
                .overflow(2);

                .group-name {
                    font-weight: bold;
                }
            }

            .quantity-box {
                .base-center-y;
                right: .pxToRem(28) [];
                height: .pxToRem(56) [];

                &.disabled {
                    .reduce,
                    .plus {
                        opacity: 0.4;
                        filter: grayscale(100%);
                    }

                    .quantity {
                        color: #979797;
                    }
                }

                .reduce {
                    position: absolute;
                    top: 0;
                    left: 0;
                    .sq(56);
                    z-index: 1;
                }

                .quantity {
                    height: .pxToRem(56) [];
                    line-height: .pxToRem(56) [];
                    padding: 0 .pxToRem(74) [];
                }

                .plus {
                    position: absolute;
                    top: 0;
                    right: 0;
                    .sq(56);
                    z-index: 1;

                    &.max {
                        opacity: 0.4;
                        filter: grayscale(100%);
                        filter: gray;
                    }
                }
            }

            .sale-out {
                .base-center-y;
                right: .pxToRem(28) [];
                color: white;
                background-color: rgba(0, 0, 0, 0.3);
                height: .pxToRem(42) [];
                line-height: .pxToRem(42) [];
                font-size: .pxToRem(24) [];
                padding: 0 .pxToRem(16) [];
                border-radius: .pxToRem(21) [];
            }

            .num {
                .base-center-y;
                right: .pxToRem(40) [];
                line-height: .pxToRem(38) [];
                font-size: .pxToRem(26) [];
                color: rgba(0, 0, 0, 0.9);
                font-weight: 600;
            }

            &::before {
                content: ' ';
                .base-center-y;
                left: .pxToRem(50) [];
                .sq(16);
                border-radius: 100%;
                background: rgba(0, 0, 0, 0.15);
            }

            &::after {
                content: ' ';
                position: absolute;
                left: .pxToRem(58) [];
                bottom: .pxToRem(-25) [];
                width: .pxToRem(1) [];
                height: .pxToRem(48) [];
                background: rgba(0, 0, 0, 0.15);
            }

            &:last-child {
                &::after {
                    width: 0;
                    height: 0;
                }
            }
        }

        .spec-group-item {
            padding-left: .pxToRem(40) [];
            padding-right: .pxToRem(40) [];

            .spec-group-name {
                display: inline-block;
                height: .pxToRem(60) [];
                line-height: .pxToRem(60) [];
                border-radius: .pxToRem(8) [];
                font-size: .pxToRem(26) [];
                padding: 0 .pxToRem(20) [];
                margin-right: .pxToRem(12) [];
                margin-bottom: .pxToRem(12) [];
                box-sizing: border-box;
                background-color: #ffffff;
                color: rgba(0, 0, 0, 0.5);
                border: .pxToRem(1) [] solid rgba(0, 0, 0, 0.5);

                &.select {
                    background: #fdf0f0;
                    color: @theme_color_first;
                    border: .pxToRem(1) [] solid @theme_color_first;
                }
            }
        }
    }

    .group-list {
        padding-left: .pxToRem(40) [];
        padding-right: .pxToRem(40) [];

        .group-item {
            display: inline-block;
            height: .pxToRem(60) [];
            line-height: .pxToRem(60) [];
            border-radius: .pxToRem(8) [];
            font-size: .pxToRem(26) [];
            padding: 0 .pxToRem(20) [];
            margin-right: .pxToRem(12) [];
            margin-bottom: .pxToRem(12) [];
            box-sizing: border-box;
            background-color: #ffffff;
            color: rgba(0, 0, 0, 0.5);
            border: .pxToRem(1) [] solid rgba(0, 0, 0, 0.5);

            &.select {
                background: #fdf0f0;
                color: @theme_color_first;
                border: .pxToRem(1) [] solid @theme_color_first;
            }
        }
    }
}

.product-detail-list {
    width: 100%;
    font-size: 0;

    img {
        width: 100%;
    }
}

.bottom {
    width: 100%;
    height: @bottomHeight;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    line-height: @bottomHeight;
    border-top: .pxToRem(1) [] solid #e5e5e5;
    box-shadow: 0 .pxToRem(8) [] .pxToRem(15) [] .pxToRem(15) [] rgba(4, 4, 4, 0.1);
    border-radius: .pxToRem(40) [] .pxToRem(40) [] 0 0;
    overflow: hidden;

    .price-line {
        height: @bottomPriceLineHeight;
        background: white;

        .total {
            .base-center-y;
            left: .pxToRem(45) [];
            font-weight: 600;
            font-size: .pxToRem(40) [];
            height: .pxToRem(40) [];
            line-height: .pxToRem(40) [];
            color: rgba(0, 0, 0, 0.9);
            padding-left: .pxToRem(28) [];

            &:before {
                content: '¥';
                position: absolute;
                left: 0;
                bottom: .pxToRem(-4) [];
                width: .pxToRem(28) [];
                text-align: center;
                height: .pxToRem(40) [];
                line-height: .pxToRem(40) [];
                font-size: .pxToRem(28) [];
                font-weight: 400;
            }
        }

        .quantity-box {
            .base-center-y;
            right: .pxToRem(28) [];
            height: .pxToRem(56) [];

            .reduce {
                position: absolute;
                top: 0;
                left: 0;
                .sq(56);
                z-index: 1;
            }

            .num {
                height: .pxToRem(56) [];
                line-height: .pxToRem(56) [];
                padding: 0 .pxToRem(74) [];
            }

            .plus {
                position: absolute;
                top: 0;
                right: 0;
                .sq(56);
                z-index: 1;
            }
        }
    }

    .btn-submit {
        height: .pxToRem(88) [];
        line-height: .pxToRem(88) [];
        text-align: center;
        color: white;
        font-size: .pxToRem(28) [];
        background: @theme_color_first;
    }
}

.cart-box {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 200;

    .cart-line {
        height: .pxToRem(100) [];
        width: .pxToRem(702) [];
        margin: 0 auto .pxToRem(48) [];

        .coupon-box {
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            width: .pxToRem(144) [];
            margin-left: .pxToRem(50) [];
            background: #333333;
            transform: skewX(-10deg);
            border-radius: 0 .pxToRem(12) [] .pxToRem(12) [] 0;

            .content {
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                transform: skewX(10deg);

                .title {
                    line-height: .pxToRem(30) [];
                    font-size: .pxToRem(28) [];
                    font-weight: 600;
                    color: white;
                }

                .coupon-count {
                    line-height: .pxToRem(26) [];
                    font-size: .pxToRem(24) [];
                    margin-top: .pxToRem(8) [];
                    color: white;
                    font-weight: 600;
                }
            }

            &::before {
                content: ' ';
                position: absolute;
                left: .pxToRem(-50) [];
                top: 0;
                bottom: 0;
                width: .pxToRem(60) [];
                height: 100%;
                background: #333333;
                transform: skewX(10deg);
                border-radius: .pxToRem(50) [] 0 0 .pxToRem(50) [];
            }
        }

        .cart-price {
            position: absolute;
            right: 0;
            top: 0;
            bottom: 0;
            left: .pxToRem(204) [];
            background-color: #d90209;
            transform: skewX(-10deg);
            margin-right: .pxToRem(50) [];
            border-radius: .pxToRem(12) [] 0 0 .pxToRem(12) [];
            transition-property: left, border-radius, background-color;
            transition-duration: 0.1s;

            &.disabled {
                background-color: #979797;
            }

            .content {
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                transform: skewX(10deg);

                .price-box {
                    position: absolute;
                    left: 0;
                    right: .pxToRem(100) [];
                    top: 0;
                    bottom: 0;
                    height: 100%;
                    margin-left: .pxToRem(12) [];
                    padding-left: .pxToRem(100) [];
                    display: flex;
                    flex-direction: column;
                    justify-content: center;

                    .product-count {
                        position: absolute;
                        top: .pxToRem(8) [];
                        left: .pxToRem(70) [];
                        background: #333333;
                        color: white;
                        width: .pxToRem(40) [];
                        text-align: center;
                        height: .pxToRem(40) [];
                        line-height: .pxToRem(40) [];
                        border-radius: 100%;
                        font-size: .pxToRem(24) [];
                        font-weight: 600;
                    }

                    .price {
                        margin-left: .pxToRem(16) [];
                        line-height: .pxToRem(48) [];
                        font-size: .pxToRem(42) [];
                        font-weight: 600;
                        color: white;
                        display: flex;
                        align-items: baseline;

                        .money-discount {
                            display: none;
                            margin-left: .pxToRem(12) [];
                            height: .pxToRem(32) [];
                            line-height: .pxToRem(32) [];
                            font-size: .pxToRem(24) [];
                        }
                    }

                    .delivery-fee {
                        display: none;
                        margin-left: .pxToRem(16) [];
                        line-height: .pxToRem(28) [];
                        font-size: .pxToRem(26) [];
                        font-weight: 600;
                        color: white;
                    }

                    &::before {
                        content: ' ';
                        position: absolute;
                        left: 0;
                        top: 50%;
                        transform: translateY(-50%);
                        width: .pxToRem(100) [];
                        height: .pxToRem(100) [];
                        background: url('~@/assets/icons/icon-cart.png');
                        background-repeat: no-repeat;
                        background-size: cover;
                    }
                }

                .submit-btn {
                    position: absolute;
                    right: .pxToRem(-20) [];
                    top: 0;
                    bottom: 0;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;

                    .title {
                        line-height: .pxToRem(38) [];
                        font-size: .pxToRem(36) [];
                        color: white;
                        font-weight: 600;
                    }

                    .tip {
                        line-height: .pxToRem(26) [];
                        font-size: .pxToRem(24) [];
                        color: white;
                        font-weight: 600;
                        text-align: center;
                    }
                }

                .no-select-product-tip {
                    line-height: .pxToRem(100) [];
                    margin-left: .pxToRem(112) [];
                    font-size: .pxToRem(36) [];
                    color: white;
                    font-size: 600;
                }
            }

            &::before {
                content: ' ';
                position: absolute;
                right: .pxToRem(-50) [];
                top: 0;
                bottom: 0;
                width: .pxToRem(60) [];
                height: 100%;
                background-color: #d90209;
                transform: skewX(10deg);
                border-radius: 0 .pxToRem(50) [] .pxToRem(50) [] 0;
                transition: background-color 0.1s;
            }

            &.disabled::before {
                background-color: #979797;
            }
        }
    }

    &.open-cart .coupon-box {
        left: .pxToRem(2) [];
        top: .pxToRem(2) [];
        bottom: .pxToRem(2) [];
    }

    &.open-cart .cart-line .cart-price {
        left: 0;
        transform: skewX(0deg);
        border-radius: .pxToRem(50) [] 0 0 .pxToRem(50) [];

        .content {
            transform: skewX(0deg);

            .price-box .price .money-discount {
                display: unset;
            }
        }

        &::before {
            transform: skewX(0deg);
        }
    }

    &.not-product .cart-line .cart-price {
        background-color: #979797;

        .content .price-box .price {
            display: none;
        }

        .content .price-box .delivery-fee {
            display: none;
        }

        .content .submit-btn {
            display: none;
        }

        &::before {
            background-color: #979797;
        }
    }

    .quantity-line {
        width: .pxToRem(702) [];
        height: .pxToRem(80) [];
        margin: 0 auto;
        background: #fdf0f0;
        border-radius: .pxToRem(40) [] .pxToRem(40) [] 0 0;

        &::before {
            content: ' ';
            position: absolute;
            bottom: .pxToRem(-45) [];
            left: 0;
            right: 0;
            height: .pxToRem(50) [];
            background-color: #fdf0f0;
        }

        .quantity-box {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: .pxToRem(28) [];
            height: .pxToRem(56) [];

            .reduce {
                position: absolute;
                top: 0;
                left: 0;
                width: .pxToRem(56) [];
                height: .pxToRem(56) [];
                z-index: 1;
            }

            .quantity {
                height: .pxToRem(56) [];
                line-height: .pxToRem(56) [];
                padding: 0 .pxToRem(74) [];
            }

            .plus {
                position: absolute;
                top: 0;
                right: 0;
                width: .pxToRem(56) [];
                height: .pxToRem(56) [];
                z-index: 1;

                &.max {
                    opacity: 0.4;
                    filter: grayscale(100%);
                    filter: gray;
                }
            }
        }
    }
}

.takeout {
    .product-list {
        .product-item {
            .name {
                right: .pxToRem(200) [];

                .price {
                    color: @theme_color_first;
                    font-size: .pxToRem(24) [];
                    font-weight: bold;
                }
            }
        }
    }

    .bottom {
        &.takeout-select-no {
            height: @bottomAddCartHeight;
            border-radius: 0;

            .price-line {
                display: none;
            }

            .btn-submit {
                filter: gray;
                filter: grayscale(100%);
            }
        }
    }
}
</style>
<style lang="less" scoped>
@import url('~@/lib/base.less');

.show-original-price {
    .detail {
        .bottom {
            .price-line {
                .price-text {
                    position: absolute;
                    top: .pxToRem(12) [];
                    left: .pxToRem(45) [];
                    height: .pxToRem(40) [];
                    line-height: .pxToRem(40) [];
                    white-space: nowrap;
                    font-weight: 600;
                    font-size: .pxToRem(40) [];
                }

                .total {
                    top: .pxToRem(12) [];
                    left: .pxToRem(170) [];
                    transform: unset;
                }

                .actual-payment {
                    position: absolute;
                    bottom: .pxToRem(2) [];
                    left: .pxToRem(45) [];
                    height: .pxToRem(32) [];
                    line-height: .pxToRem(32) [];
                    font-size: .pxToRem(24) [];
                    color: rgba(0, 0, 0, 0.9);
                }
            }
        }
    }
}
</style>
